export enum PhoneNumberType {
    Mobile = "Mobile",
    Home = "Home",
    Office = "Office",
    WhatsApp = "WhatsApp",
    Other = "Other",
}
export enum DocumentType {
    CV = 'cv',
    ID="ID",
    Contract = 'contract',
    Certificate = 'certificate',
    License = 'license',
    BusinessCard = 'business card',
    Visa = 'visa',
    Passport = 'passport',
    Insurance= 'insurance',
    CompanyProfile = 'company profile',
    Additional= 'additional',
    PriceSheet = 'price sheet',
    Policy="policy",
    NDA="NDA",
}

export enum DocumentEntityType {
    Client = 'clients',
    Contact = 'contacts',
    Provider = 'providers',
    Organization = 'organizations',
    Company = 'companies',
    User = 'users',
    MissionRequest = 'mission-requests',
    Asset = 'assets',
    Service = 'services',
    PaymentInfo = 'payment-info',
    Mission = 'missions',
    ItineraryExpense = 'itinerary-expenses',
    LegExpense = 'leg-expenses',
    EntityRequest = 'entity-requests',
    Task = 'tasks',
    Lead = 'leads',
}

export type Region = {
    regionId: number | null;
    name: string;
    createdBy:number;
    deletedAt: Date|null;
    countries: Country[] | null;
}
export type Continent = {
    continentId: number | null;
    name: string;
    code:string;
    createdBy:number;
    deletedAt: Date|null;
    countries: Country[] | null;
}
export type Country = {
    countryId: number | null;
    name: string;
    nationality: string;
    iso2Code: string;
    iso3Code: string;
    taxRate:number;
    createdBy:number;
    deletedAt: Date|null;
    states: State[] | null;
    region:Region | null;
    continent: Continent | null;
}
export type State = {
    stateId: number | null;
    name: string;
    code:string;
    taxRate:number;
    createdBy:number;
    deletedAt: Date|null;
    country: Country | null;
}
export type City = {
    cityId: number | null;
    name: string;
    latitude: number;
    longitude: number;
    createdBy:number;
    deletedAt: Date|null;
    country: Country | null;
    state: State | null;
    timeZone: TimeZone | null;
}
export type TimeZone = {
    timeZoneId: number | null;
    name: string;
    description: string;
    createdBy:number;
    deletedAt: Date|null;
}

export type Tag = {
    tagId: number | null;
    name: string;
    description: string;
    color: Color | null;
    createdBy:number;
    deletedAt: Date|null;
    type:TAG_TYPE | null;
}
export enum TAG_TYPE {
    CONTACT = 'contact',
    LEAD = 'lead',
    PROVIDER = 'provider',
    CLIENT = 'client',
}

export type Color = {
    colorId: number | null;
    name: string;
    hexCode: string;
    description:string;
    deletedAt: Date|null;
    createdBy:number;
}

export enum InitialEncounterSourceType {
    Call = 'call',
    Email = 'email',
    ExistingCustomer = 'existing customer',
    Partner = 'partner',
    PublicRelations = 'public relations',
    Website = 'website',
    Campaign = 'campaign',
    Event = 'event',
    LinkedIn = 'linkedIn',
    Facebook = 'facebook',
    Referral = "referral",
    BusinessCard = "business card",
    Other = 'other',
}


export enum PaymentType {
    Bank = 'Bank',
    ExchangeCenter = 'Exchange center',
    //Visa = 'Visa',
    Click = 'Cliq',
    //WesternUnion = 'Western union',
    Cash = 'Cash',
    Cheque = 'Cheque',
    Indirect='Indirect/Referral'
}

export enum TransportationType {
    Ground = 'Ground',
    Rails = 'Rails',
    Airborne = 'Airborne',
    Naval = 'Naval',
    Other = 'Other',
}

export enum AssetType {
    Luxury = 'Luxury',
    Standard = 'Standard',
}

export enum BodyStyleType {
    Armoured = 'Armoured',
    Sedan = 'Sedan',
    SUV = 'SUV',
    Van = 'Van',
    MiniVan = 'Minivan',
    Minibus = 'Minibus',
    Bus = 'Bus',
    Other = 'Other',
}

export type Manufacturer = {
    manufacturerId: number | null;
    name:string;
    description:string;
    deletedAt: Date|null;
    createdBy:number | null;
};

export type Expense = {
    expenseId: number | null;
    name:string;
    description:string | null;
    deletedAt: Date|null;
    createdBy:number | null;
}

export type Incident = {
    incidentId: number | null;
    name: string | null;
    description: string | null;
    deletedAt: Date | null;
    createdBy: number | null;
}
export type Language = {
    languageId: number| null;
    name: string;
    code: string;
    nativeName: string;
    createdBy:number;
    deletedAt: string| null;
}


export type Service = {
    serviceId: number | null;
    name: string;
    description: string;
    serviceReferenceNumber:string;
    createdBy:number;
    deletedAt: Date|null;
    subServices: SubService[] | null;
}


export type SubService = {
    subServiceId: number | null;
    name: string;
    description: string;
    subServiceReferenceNumber:string;
    createdBy:number;
    deletedAt: Date|null;
    service: Service | null,
}


export type Airport = {
    airportId: number | null;
    name: string;
    description: string;
    iataCode: string;
    latitude: number;
    longitude: number;
    createdBy:number;
    deletedAt: Date|null;
    country: Country | null;
    city: City | null;
}

export type JobPosition = {
    jobPositionId: number | null;
    name:string;
    description:string;
    deletedAt: Date|null;
    createdBy:number;
}

export type OrganizationSpecialty = {
    specialtyId: number | null;
    name:string;
    description:string;
    deletedAt: Date|null;
    createdBy:number;
}

export enum RateType {
    Year = 'Year',
    Month = 'Month',
    Day = 'Day',
    Hour = 'Hour',
    Transfer= 'Transfer',
}
export enum OverTimeRateType {
    Percentage = 'Percentage',
    Fixed = 'Fixed',
}

/**
 * Discriminator for a resource row on a MissionRequest / Mission location
 * service. Mirrors the backend `ResourceKind` enum:
 *  - Asset    : non-human capacity slot (vehicle, equipment, room). No
 *               assigned operator allowed.
 *  - Operator : human staff slot. May optionally link an assigned operator
 *               (a User) — the slot can stay unassigned until sourcing is
 *               finalized.
 *
 * Lets a single service carry e.g. "car from provider X + driver from
 * provider Y" as two independent rows with different providers.
 */
export enum ResourceKind {
    Asset = 'asset',
    Operator = 'operator',
}

/**
 * Five-axis classification of a resource line — mirrors the backend
 * `ResourceType` enum. Drives the conditional form shape on the
 * provider price-sheet editor + MR / Mission resource editors and the
 * Standard Rate Catalog filter / column rendering.
 *
 *  - Bundle    : vehicle + crew together
 *  - Vehicle   : vehicle only
 *  - Crew      : operator(s) only
 *  - Equipment : driven by EquipmentType lookup
 *  - Other     : driven by ServiceCategoryType lookup + description
 */
export enum ResourceType {
    Bundle = 'bundle',
    Vehicle = 'vehicle',
    Crew = 'crew',
    Equipment = 'equipment',
    Other = 'other',
}

/**
 * Picker shape for the `equipment` resource type. Returned by the
 * `lookups/equipment-types` endpoint — id + name only is what the FE
 * editor needs.
 */
export type EquipmentType = {
    equipmentTypeId: number | null;
    name: string;
    category: string | null;
    isActive?: boolean;
    displayOrder?: number;
    deletedAt?: Date | null;
};

/**
 * Picker shape for the `other` resource type. Returned by the
 * `lookups/service-category-types` endpoint.
 */
export type ServiceCategoryType = {
    serviceCategoryTypeId: number | null;
    name: string;
    category: string | null;
    isActive?: boolean;
    displayOrder?: number;
    deletedAt?: Date | null;
};

/**
 * Three hardcoded shape discriminators on a LegType lookup row. Each
 * one drives a different field layout on the leg editor and a different
 * chip rendering on the mobile timeline:
 *   - `Movement` — A → B leg (from + to addresses + drive window)
 *   - `Static`   — hold-at-one-location post (single address)
 *   - `Standby`  — time window only, location optional
 *
 * Adding a new shape requires a code change here AND in the leg editor
 * + mobile cards (they need to learn how to render it). Adding a new
 * leg TYPE that reuses an existing shape is admin-only.
 */
export enum LegTypeShape {
    Movement = "movement",
    Static = "static",
    Standby = "standby",
}

/**
 * Admin-managed lookup classifying a Leg's operational kind. Embedded
 * on `Leg.legType` so the editor + mobile cards can read shape, color,
 * and icon without an extra round-trip. Returned by both the lookups
 * picker endpoint (`/lookups/leg-types`) and the admin CRUD endpoints
 * (`/leg-types`) — the admin shape carries the additional audit fields.
 */
export type LegType = {
    legTypeId: number;
    name: string;
    code: string;
    shape: LegTypeShape;
    color: string;
    icon: string | null;
    description?: string | null;
    displayOrder?: number;
    isActive?: boolean;
    deletedAt?: Date | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    createdBy?: number | null;
    updatedBy?: number | null;
};
/** What people type → what the system calls it ("KSA" → "Saudi Arabia"). Lookups → Search Aliases. */
export type SearchAlias = {
    searchAliasId: number | null;
    alias: string;
    target: string;
    type: "place" | "service" | "text";
    description: string;
    deletedAt: Date | null;
    createdBy: number;
};
